export const symbols = ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
                        'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
                        '+', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', '-'] 
export const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'X']
export const specialSymbols = [" ", "—", ',', '.', '"', '(', ')', ':', "'", "{", '}', '-', '/', '•']

export const colorMap: {[key: string]: string} = {
    "W": "white",
    "U": "blue",
    "B": "black",
    "R": "red",
    "G": "green",
    "C": "colorless"
}

export const buttonBackground = "#25292E"

export const buttonMap: {[key: string]: string} = {
    "A": buttonBackground,
    "B": buttonBackground,
    "C": buttonBackground,
    "D": buttonBackground,
    "E": buttonBackground,
    "F": buttonBackground,
    "G": buttonBackground,
    "H": buttonBackground,
    "I": buttonBackground,
    "J": buttonBackground,
    "K": buttonBackground,
    "L": buttonBackground,
    "M": buttonBackground,
    "N": buttonBackground,
    "O": buttonBackground,
    "P": buttonBackground,
    "Q": buttonBackground,
    "R": buttonBackground,
    "T": buttonBackground,
    "U": buttonBackground,
    "S": buttonBackground,
    "V": buttonBackground,
    "W": buttonBackground,
    "X": buttonBackground,
    "Y": buttonBackground,
    "Z": buttonBackground,
    "0": buttonBackground,
    "1": buttonBackground,
    "2": buttonBackground,
    "3": buttonBackground,
    "4": buttonBackground,
    "5": buttonBackground,
    "6": buttonBackground,
    "7": buttonBackground,
    "8": buttonBackground,
    "9": buttonBackground,
    "+": buttonBackground,
    "-": buttonBackground,
}

export const colorToSymbolMap = {
    "W": '⚪️',
    "U": '🔵',
    "B": '⚫',
    "R": '🔴',
    "G": '🟢',
    "C": '🔘',
    "M": '🟡',
    "H": '💀',
}

export const squareMap: {[key: string]: string} = {
    "correct": '🟩',
    "incorrect": '🟥',
    // "": '🔲',
    "": ""
}
